/**
 * DER HAUSFILTER DER GUIDE-FLAECHE — Speicherplatz und Werte, EINMAL definiert.
 *
 * Der Reiter „Dev | Partner" im Guide ist kein Adress-Parameter, sondern eine
 * Wahl im sessionStorage des Browsers (GuideFlaeche.tsx: `setzeGuideHausfilter`,
 * `useGuideHausfilter`). Bis 21.10.2026 kannte nur der Client diesen Schluessel.
 * Seitdem will auch der Server ihn setzen: `GET /api/capture/guide?haus=partner`
 * (routes/screenshots.ts) legt ihn vor dem Laden der Seite in den Aufnahme-Browser,
 * damit das Bild den Partner-Reiter zeigt, so wie Rafael ihn nach dem Klick sieht
 * (Rafael, 21.10.2026 11:11Z, Buehne b-partner-reiter-fotografierbar-20261021).
 *
 * Zwei Seiten, ein Schluessel: stuende der Text an beiden Orten, zeigte die Aufnahme
 * nach einer Umbenennung still wieder Dev — und saehe aus wie ein Gegenbeweis.
 */

/** sessionStorage-Schluessel je Flaeche; die Hauswahl liegt unter `uebersicht`. */
export function guideSchalterSchluessel(pfad: string): string {
  return `cui.guideflaeche.schalter.${pfad}`;
}

export const GUIDE_HAUSFILTER_PFAD = 'uebersicht';

/** Die beiden Schalter-Kennungen der Hauswahl (Coach-Uebersicht `cu-h1`/`cu-h2`). */
export const GUIDE_HAUS_SCHALTER = { dev: 'cu-h1', partner: 'cu-h2' } as const;

/**
 * Der fertige sessionStorage-Eintrag fuer EIN Haus, als Schluessel/Wert-Paar — genau
 * das, was `setzeGuideHausfilter(haus)` im Browser schreibt, wenn vorher nichts
 * gemerkt war. Der Server benutzt es per `addInitScript`, bevor die Seite laedt.
 */
export function guideHausfilterEintrag(haus: 'dev' | 'partner'): { schluessel: string; wert: string } {
  return {
    schluessel: guideSchalterSchluessel(GUIDE_HAUSFILTER_PFAD),
    wert: JSON.stringify([GUIDE_HAUS_SCHALTER[haus]]),
  };
}
